<template>
  <div class="order">
    <div class="header">
      <div class="w clearfix">
        <div class="logo" @click="goIndex()">
          <img class="sy_logo" :src="logoUlr" />
        </div>
        <div class="msg">确认订单信息</div>
      </div>
    </div>
    <div id="content" class="w" v-for="(olst,i) in orderList" :key="i">
      <div class="checkout-steps " >
        <div class="w">
          <strong class="orderInfo">订单信息__{{olst[0][0].jname}}</strong>
          <table
            width="100%"
            border="1"
            cellpadding="0"
            cellspacing="0"
            style="table-layout:fixed;"
          >
            <thead>
              <th width="38">序号</th>
              <th width="88">第三方单号</th>
              <th width="178">规格</th>
              <th width="278">文件</th>
              <th width="98">数量*款数</th>
              <th width="78">价格</th>
              <th width="48">重量</th>
              <th width="88">物流方式</th>
              <th width="78">运费</th>
              <th width="78">包装费</th>
              <th width="78">小计</th>
              <th width="78">操作</th>
            </thead>
           <tbody v-for="(item,index) in olst" :key="item[0].id">
              <!-- 拆包布局 -->
              <template v-if="item.length==1">
                <tr class="one">
                  <td rowspan="2" width="68">{{index+1}}</td>
                  <td style="white-space:normal;word-break:break-all;">
                    <template v-if="item[0].otherno!==null">{{item[0].otherno}}</template>
                  </td>
                  <td width="258">{{item[0].title}}</td>
                  <td width="208" style="word-wrap:break-word">{{item[0].filename.slice(77)}}</td>
                  <td width="98">{{item[0].number}}{{item[0].product_unit}}X{{item[0].kuanshu}}款</td>
                  <td width="68" class="co-red">￥{{item[0].goods_price+item[0].craft_price}}元</td>
                  <td width="58">{{item[0].product_weight}}kg</td>
                  <td width="88">
                    <select
                     v-model="item[0].express_id"
                      :name="'express'+index"
                      :id="'express'+item[0].id"
                      class="kuaidiSelect"
                      @change="addressChange($event,item[0].id,item[0].address_id)"
                    >
                      <template v-for="(item2,index) in item[0].expressList">
                        <option
                          v-if="item2.id==item[0].express_id"
                          :value="item2.id"
                          :key="item2.id"
                          selected
                        >{{item2.express_name}}</option>
                        <option v-else :value="item2.id" :key="index">{{item2.express_name}}</option>
                      </template>
                    </select>
                  </td>
                  <td width="68" class="co-red">￥{{item[0].realy_ship_price}}元</td>
                  <td width="68" class="co-red">￥{{item[0].packprice}}元</td>
                  <td
                    width="68"
                    class="co-red"
                  >￥{{ parseFloat(item[0].total_price) + parseFloat(item[0].realy_ship_price) + parseFloat(item[0].packprice) }}元</td>
                  <td rowspan="4" style="width:98px">
                    <div>
                      <el-button
                        type="info"
                        class="delete"
                        size="mini"
                        @click="delShopCar(item[0].id)"
                      >删除</el-button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="10" class="address clearfix">
                    {{'地址:'+ item[0].address_text}} {{item[0].address_query}} {{item[0].shopping_name}} {{item[0].shopping_phone}}
                   {{item[0].ext_number?'转'+item[0].ext_number:''}}
                    <button
                      class="addressSettings"
                      @click="showDialog(item[0].address_id,item[0].id,$event)"
                    >地址管理</button>
                  </td>
                </tr>
                <tr>
                  <td colspan="11" style="padding:0;height:10px;background-color:#fafafa"></td>
                </tr>
              </template>

              <!-- 合包布局 -->
              <template v-else>
                <!-- <template v-if="item[1]"> -->
                <template v-for="(item1,index1) in item">
                  <tr v-if="index1==0" class="one">
                    <td :rowspan="item.length+1">{{index+1}}</td>
                    <td :rowspan="item.length" style="white-space:normal;word-break:break-all;">
                      <template v-if="item1.otherno!==null">{{item1.otherno}}</template>
                    </td>
                    <td>{{item1.title}}</td>
                    <td style="word-wrap:break-word">{{item1.filename.slice(77)}}</td>
                    <td>{{item1.number}}{{item1.product_unit}}X{{item1.kuanshu}}款</td>
                    <td class="co-red">￥{{item1.total_price}}元</td>
                    <td :rowspan="item.length">
                      <h2>总计:</h2>
                      {{item1.total_weight}}kg
                    </td>
                    <td :rowspan="item.length">
                      <select
                        :name="'expressHe'+index"
                        :id="'express'+index"
                        class="kuaidiSelect"
                        @change="addressChange($event,item.ids,item[0].address_id)"
                      >
                        <template v-for="(item2) in item[0].expressList">
                          <option
                            v-if="item2.id==item[0].express_id"
                            :value="item2.id"
                            :key="item2.id"
                            selected
                          >{{item2.express_name}}</option>
                          <option v-else :value="item2.id" :key="item2.id">{{item2.express_name}}</option>
                        </template>
                      </select>
                    </td>
                    <td :rowspan="item.length" class="co-red">
                      <h2>总计:</h2>
                      ￥{{item1.realy_ship_price}}元
                    </td>
                    <td >
                      ￥{{item1.packprice}}元
                    </td>
                    <td :rowspan="item.length" class="co-red">
                      <h2>总计:</h2>
                      ￥{{parseFloat(item.xiaoji)}}元
                    </td>
                    <td :rowspan="item.length" style="width:98px">
                      <!-- <div>
                        <el-button type="success" class="Chai" size="mini">拆包</el-button>
                      </div>

                      <div>
                        <el-button type="info" class="delete" size="mini">删除</el-button>
                      </div>-->
                    </td>
                  </tr>
                  <tr v-else>
                    <td>{{item1.title}}</td>
                    <td style="word-wrap:break-word">{{item1.filename.slice(77)}}</td>
                    <td>{{item1.number}}{{item1.product_unit}}X{{item1.kuanshu}}款</td>
                    <td class="co-red">￥{{item1.total_price}}元</td>
                    <td >￥{{item1.packprice}}元</td>
                  </tr>
                </template>

                <!-- </template> -->

                <tr>
                  <td colspan="10" class="address clearfix">
                    {{'地址:'+ item[0].address_text}} {{item[0].address_query}} {{item[0].shopping_name}} {{item[0].shopping_phone}}
                    <button
                      class="addressSettings"
                      @click="showDialog(item[0].address_id,item.ids,$event)"
                    >地址管理</button>
                  </td>
                </tr>
                <tr>
                  <td colspan="11" style="padding:0;height:10px;background-color:#fafafa"></td>
                </tr>
              </template>
            </tbody>
          </table>
          <!-- 地址管理 -->
          <el-dialog title="地址管理" :visible.sync="dialogVisible" width="50%">
            <el-button type="primary" size="small" id="addAddress" @click="addaddress()">添加地址</el-button>
            <el-input style="width:200px;margin-left:20px" size="small"  v-model="soaddress"   placeholder="输入姓名,电话,地址搜索"></el-input>
            <el-button style="margin-left:20px" size="small" type="success" @click="autoaddress">搜索</el-button>
            <div id="addressBox"style="height: 410px;overflow-y: scroll;">
              <template v-if="JSON.stringify(AddressList) !='[]'">
                <div
                  v-for="item in AddressList"
                  :id="item.id"
                  :class="item.id==currentId ? 'clearfix address-item active' : 'clearfix address-item'"
                  :key="item.id"
                >
                  <button class="un">{{item.shopping_name}}</button>
                  <p class="address1" :title="item.address">{{item.address}}</p>
                  <p class="Addressquery" :title="item.query">{{item.query}}</p>
                  <p class="AddressPhone">{{item.shopping_phone}}</p>
                  <p class="ext_number" v-show="item.ext_number">转{{item.ext_number}}</p>
                  <div class="caozuo" v-if="item.def==0">
                    <button  class="el-button el-button--primary el-button--small" @click="checkAddress(item.id)">选择</button>
                    <span style="margin-left: 10px;" class="set" @click="settingAddress(item.id)">设置默认</span>
                    <a class="edit" @click="editShowDialog(item)">修改</a>
                    <button class="del" @click="delAddress(item.id)">删除</button>
                  </div>
                  <div class="caozuo" v-else>
                    <button  class="el-button el-button--primary el-button--small" @click="checkAddress(item.id)">选择</button>
                    <button style="margin-left: 10px;"  class="def">默认地址</button>
                    <a class="edit" @click="editShowDialog(item)">修改</a>
                  </div>
                </div>
              </template>
              <div v-else>暂无数据</div>
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>

            </span>
          </el-dialog>

          <el-dialog :visible.sync="dialogVisible1" class="dia-title" title="添加地址" width="40%">
            <el-form
              style="margin-top:10px"
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
            <el-form-item label="自动识别">
              <el-input style="width:450px" v-model="autoAdd" placeholder="淘宝单号,文件名,手机,姓名"></el-input>
              <el-button style="margin-left:20px" type="success" @click="autoSpot">开始识别</el-button>
            </el-form-item>
              <el-form-item label="收货人姓名" prop="shopping_name">
                <el-input v-model="ruleForm.shopping_name" placeholder="姓名长度不超过25个字符"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="shopping_phone">
                <el-input v-model="ruleForm.shopping_phone" placeholder="请输入收货人的手机号码"></el-input>
              </el-form-item>
              <el-form-item label="分机号" prop="ext_number">
                <el-input v-model="ruleForm.ext_number" placeholder="请输入分机号"></el-input>
              </el-form-item>
              <v-distpicker  class="address_picker" style="margin:0 0 10px 100px" @selected="onSelected"></v-distpicker>
              <el-form-item label="详细地址" prop="query">
                <el-input v-model="ruleForm.query" placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible1 = false">取 消</el-button>
              <el-button type="primary" @click="submitForm('ruleForm')" class="diz">添加地址</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
      <div id="summary" class="clearfix">
        <div class="statistic">
          <div class="list">
            <span>用户余额：</span>
            <i class="co-red" style="font-size:20px;">￥{{olst[0][0].umoney}}元</i>
          </div>
          <div class="list">
            <span>
              <i class="co-red" style="font-size:16px; font-weight:bold">{{orderCount[i]}}</i> 个订单，总商品金额：
            </span>
            <i class="co-red" style="font-size:20px;">￥{{totalPrice1[i]}}元</i>
          </div>
          <div class="list">
            <span>其中包含运费：</span>
            <i class="co-red" style="font-size:20px;">￥{{totalCost1[i]}}元</i>
          </div>
          <!-- <div class="list">
            <span>优惠金额：</span>
            <i class="co-red" style="font-size:20px;">￥80.00</i>
          </div>-->
        </div>
      </div>
      <div id="foot" class="clearfix">
        <div class="SY clearfix">
          <div class="priceInfo">
            <div class="price">
              <span>应付金额：</span>
              <strong class="co-red" style="font-size:34px;">￥{{countPrice[i]}}元</strong>
            </div>
            <!-- <div class="userInfo">
              <span>寄送至：师大的哈市的接口撒谎的框架爱上的框架爱售点卡坚实的哈市框架萨的还框架萨的还</span>
            </div>-->
          </div>
        </div>
      </div>
      <div id="sticky-wrap" class="clearfix">
        <button  class="paymentOrder" :attr-uid = "olst[0][0].uid" :attr-i = "i" >提交订单</button>
      </div>
    </div>
    <Fotter></Fotter>
  </div>
</template>
<script>
import Fotter from '../components/index/fotter'
import VDistpicker from 'v-distpicker'

export default {
  components: {
    Fotter,
    VDistpicker
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      zhifuMethod: 1,
      autoAdd: '',
      soaddress: '',
      ruleForm: {
        // 省id
        provice_id: '',
        // 省市区id
        address: [],
        // 详细地址信息
        query: '',
        // 名字
        shopping_name: '',
		ext_number: '',
        // 手机号码
        shopping_phone: '',
        token: window.localStorage.getItem('token'),
        id: ''
      },
      AddressList: [],
      rules: {
        shopping_name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        shopping_phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '请核对手机号码', trigger: 'blur' }
        ],
        query: [
          { required: true, message: '请输入配送地址', trigger: 'blur' },
          {
            min: 5,
            max: 120,
            message: '详细地址长度需要在5-120个汉字或字符之间',
            trigger: 'blur'
          }
        ]
      },
      orderList: [],
      token: '',
      expressList: [],
      // 订单数
      orderCount: [],
      // 总运费
      totalCost: [],
      totalPrice: [],
      totalCost1: [],
      totalPrice1: [],
      // 拆包荷包
      key: [],
      // 数据重量
      w: [],
      // 数据价格
      p: [],
      f: 0,
      t: [],
      flag: 0,
      // 默认选中的地址id
      currentId: '',
      // 订单id
      orderId: '',
      // 快递id
      addressID: '',
      // 余额
      yue: '',
      logoUlr: '',
      // 购物车id
      carid: [],
      WeChatPay: false,
      AliPay: false
    }
  },
  computed: {
    countPrice() {
      return this.totalPrice1
    }
  },
  created() {
    let sy_info = window.sessionStorage.getItem('sy_info')
    this.logoUlr = JSON.parse(sy_info).logo
    if (!window.localStorage.getItem('token')) {
      this.$router.push('/login')
      return
    }
    this.token = window.localStorage.getItem('token')
    this.queryOrderList()

    this.queryEDList()
    this.queryPayMethods()
  },
  mounted() {
    const that = this
    $('.methods .method-box').on('click', 'li', function() {
      $(this)
        .addClass('current')
        .siblings('li')
        .removeClass('current')
      that.zhifuMethod = $(this).attr('id')
    })
    this.$nextTick(_ => {
      this.getYue()
    })
    $(document).unbind('click').on('click', '.paymentOrder', function() {
      $(this).css('background', '#999')
        $(this).removeClass('paymentOrder')
            var i = $(this).attr('attr-i')
            var uid = $(this).attr('attr-uid')
            console.log(i, uid)

           that.paymentOrder(i, uid)
    })
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', this.token)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })

      this.yue = res.data.money
      console.log(this.yue)
    },
    // 验证信息填写是否完全
    submitForm(formName) {
      if (this.ruleForm.address.length < 3) {
        this.$message('请选择完整的省市区', 'error')
        return false
      }
      for (let i = 0; i < this.ruleForm.address.length; i++) {
        if (!this.ruleForm.address[i]) {
          this.$message('请选择完整的省市区', 'error')
          return false
        }
      }
       let address = this.ruleForm.address
      this.$refs[formName].validate(async valid => {
        if (!valid) {
          return false
        } else {
          if (!this.ruleForm.provice_id || !address) {
            this.$message('请选择详细地区信息', '提示')
            return false
          }

          this.ruleForm.address = address
          let param = new URLSearchParams()
          for (let key in this.ruleForm) {
            param.append(key, this.ruleForm[key])
          }

          // 添加地址
          if (this.flag == 0) {
            const { data: res } = await this.$http({
              method: 'post',
              url: 'api/address/addaddress',
              data: param
            })
            if (res.code == 1) {
              this.$confirm('添加地址信息成功！', '提示')
              this.queryAddress()
              this.dialogVisible1 = false
              this.$refs[formName].resetFields()
              this.ruleForm.address = this.ruleForm.address.split(',')
            } else {
              this.$message.error('添加地址失败')
            }
          } else if (this.flag == 1) {
            const { data: resu } = await this.$http({
              method: 'post',
              url: 'api/address/editaddress',
              data: param
            })
            if (resu.code == 1) {
              this.$message.success('修改地址成功！', '提示')
              this.queryAddress()
              this.dialogVisible1 = false
              this.$refs[formName].resetFields()
              this.ruleForm.address = this.ruleForm.address.split(',')
            }
          }
        }
      })
    },
    onSelected(data) {
      this.ruleForm.address = []
      this.ruleForm.provice_id = ''
      this.ruleForm.provice_id = data.province.code
      for (let key in data) {
        this.ruleForm.address.push(data[key].code)
      }

      // console.log(this.ruleForm)
    },
    showDialog(id, orderId, e) {
      // 地址快递的id
      this.addressID = $(e.currentTarget)
        .parents('tbody')
        .children('.one')
        .find('.kuaidiSelect')
        .val()
      this.dialogVisible = true
      this.flag = 0
      this.currentId = id
      this.orderId = orderId
      // console.log(id) 地址id
      // console.log(orderId) 订单id
      this.queryAddress()

      // dom更新完成添加点击事件
      this.$nextTick(() => {
        $('#addressBox').on('click', '.address-item', function() {
          $(this)
            .addClass('active')
            .siblings('.address-item')
            .removeClass('active')
        })
      })
    },
    // 删除购物车内订单
    async delShopCar(id) {
      let param = new URLSearchParams()
      param.append('ids', id)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/delcar',
        data: param
      })
      if (res.code == 1) {
        this.key = []
        this.queryOrderList()
      } else {
        alert('删除失败')
      }
    },
    // 切换快递方式
    async addressChange(e, orderId, addressId) {
      // 快递方式id
      let express_id = $(e.currentTarget).val()
      let param = new URLSearchParams()
      param.append('id', orderId)
      param.append('express_id', express_id)
      param.append('address_id', addressId)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/editcaraddress',
        data: param
      })
      // console.log(res)
      // this.queryEDList()
      this.queryOrderList()
    },
    // 添加地址
    addaddress() {
      this.flag = 0
      this.dialogVisible1 = true
      $('.diz span').text('添加地址')
    },
    // 切换地址
    async checkAddress(id) {
      let address_id = id

      if (address_id == '') {
        this.$confirm('请选择收货地址')
        return
      }
      let param = new URLSearchParams()
      param.append('id', this.orderId)
      param.append('express_id', this.addressID)
      param.append('address_id', address_id)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/editcaraddress',
        data: param
      })
      if (res.code == 1) {
        this.$confirm('修改收货地址成功', '提示')
        this.queryOrderList()
        this.dialogVisible = false
      }
    },
    // 点击编辑
    editShowDialog(data) {
      this.ruleForm.shopping_name = data.shopping_name
      this.ruleForm.shopping_phone = data.shopping_phone
            this.ruleForm.ext_number = data.ext_number
      this.ruleForm.query = data.query
      this.ruleForm.id = data.id
      this.dialogVisible1 = true
      this.flag = 1
      $('.diz span').text('修改地址')
    },
    // 设置默认地址
    async settingAddress(id) {
      let param = new URLSearchParams()
      param.append('id', id)
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/address/defaddress',
        data: param
      })
      if (res.code == 1) {
        this.$message.success('设置成功')
        this.queryAddress()
      }
    },
    // 删除地址
    delAddress(id) {
      this.$confirmm('此操作将永久删除该地址, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let param = new URLSearchParams()
          param.append('id', id)
          const { data: res } = await this.$http({
            method: 'post',
            url: '/api/address/deladdress',
            data: param
          })
          // console.log(res)
          if (res.code == 1) {
            this.$confirm('删除成功', '提示')
          }
          this.queryAddress()
        })
        .catch(() => {})
    },
    // 递归排序
    compare(property) {
      return function(a, b) {
        return b[property] - a[property]
      }
    },
    // 查询地址列表
    async queryAddress(id = '', linmt = '100') {
      let token = window.localStorage.getItem('token')
      if (token) {
        let param = new URLSearchParams()
        param.append('token', token)

        param.append('linmt', linmt)
        const { data: res } = await this.$http({
          method: 'post',
          url: '/api/address/index',
          data: param
        })
        if (res.code == 1) {
          this.AddressList = res.data.sort(this.compare('def'))
        } else {
          this.AddressList = []
        }
      }
    },
    goIndex() {
      this.$router.push('/index')
    },
    // 查询订单
    async queryOrderList() {
      let param = new URLSearchParams()
      param.append('token', this.token)

        param.append('cartype', 2)

      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/detailD',
        data: param
      })

      let datas = res.data
      let yunfei = 0
      let xiaoji = 0
      let ids = []
      let carid = []
      let key = []
      let k = []
      let w = []
      let p = []
      let t = []

      if (res.code == 1) {
        this.t = []
        this.p = []
        for (let kk in datas) {
        let idss = []
        let ids = []

        let ks = []
        let ws = []
        let ps = []
        let keys = []
        this.orderCount[kk] = 0
        this.totalCost[kk] = 0
        this.totalPrice[kk] = 0
        this.totalCost1[kk] = 0
        this.totalPrice1[kk] = 0
      for (let key in datas[kk]) {
          yunfei = 0
          xiaoji = 0

          if (datas[kk][key].length > 1) {
            for (let j in datas[kk][key]) {
              ks.push(datas[kk][key][j].k)
              console.log(datas[kk][key][j].k)
              console.log('pppppp')
              console.log(ks)

              idss.push(datas[kk][key][j].id)
              this.totalPrice[kk] += datas[kk][key][j].total_price
              this.totalPrice1[kk] += datas[kk][key][j].total_price

              this.totalPrice[kk] += parseFloat(datas[kk][key][j].packprice)
              this.totalPrice1[kk] += parseFloat(datas[kk][key][j].packprice)
              // parseFloat()
              xiaoji += datas[kk][key][j].total_price
              xiaoji += parseFloat(datas[kk][key][j].packprice)
                ws.push(datas[kk][key][j].total_weight)
              ps.push(datas[kk][key][j].total_ship_price)
            }

            datas[kk][key].k = ks.join(',')
            // ids.push(idss.join(','))
             datas[kk][key].ids = idss.join(',')
            if (keys.length < datas[kk].length) {
              keys.push(datas[kk][key].k)
            }

            yunfei = datas[kk][key][0].total_ship_price
            datas[kk][key].yunfei = parseFloat(yunfei)
            datas[kk][key].xiaoji =
              xiaoji + parseFloat(datas[kk][key][0].realy_ship_price)
            this.totalPrice[kk] += datas[kk][key].yunfei
            this.totalCost[kk] += datas[kk][key].yunfei
            this.totalPrice1[kk] += datas[kk][key][0].realy_ship_price
            this.totalCost1[kk] += datas[kk][key][0].realy_ship_price
          }

            if (datas[kk][key].length <= 1) {
              keys.push(datas[kk][key][0].k)

              console.log(keys)
              console.log(111111111111)
              ws.push(datas[kk][key][0].total_weight)
              ps.push(datas[kk][key][0].total_ship_price)
            }

          // 计算总得价格
          if (datas[kk][key].length <= 1) {
            idss.push(datas[kk][key][0].id)
            this.totalPrice[kk] +=
              datas[kk][key][0].total_price +
              parseFloat(datas[kk][key][0].packprice) +
              parseFloat(datas[kk][key][0].total_ship_price)
            this.totalCost[kk] += parseFloat(datas[kk][key][0].total_ship_price)
            this.totalPrice1[kk] +=
              datas[kk][key][0].total_price +
              parseFloat(datas[kk][key][0].packprice) +
              parseFloat(datas[kk][key][0].realy_ship_price)
            this.totalCost1[kk] += parseFloat(datas[kk][key][0].realy_ship_price)
          }
          this.orderCount[kk] += 1
        }
        ids.push(idss)
        carid.push(idss.join(','))
        key.push(keys.join(','))

        w.push(ws)
        p.push(ps)

        k.push(ks)
      }
      this.carid = carid
      this.key = key
      this.ids = ids
      this.w = w
      this.p = p
      // this.ids = ids;

        // this.key[kk] = this.key[kk].join(',')
      console.log(datas)
      console.log(22222222222222222222)

        this.orderList = datas

        console.log(this.orderCount)
        console.log(this.totalPrice)
        console.log(2344455)
        console.log(this.ids)
        console.log(123123)

          for (let ki in datas) {
            let ts = []
           for (let kkk in datas[ki]) {
              if (datas[ki][kkk].length > 1) {
                for (let i = 0; i < datas[ki][kkk].length; i++) {
                  ts.push(datas[ki][kkk].xiaoji) + parseFloat(datas[ki][kkk][0].packprice)
                }
              } else {
                ts.push(
                  parseFloat(datas[ki][kkk][0].realy_ship_price) +
                    parseFloat(datas[ki][kkk][0].total_price) +
                    parseFloat(datas[ki][kkk][0].packprice)
                )
              }
        }
           this.t.push(ts)
          }

        this.f++

        // console.log(this.key)
        // // console.log(this.w.join(','))
        // console.log(this.p.join(','))
        // console.log(this.t.join(','))
        // console.log(data)
        // console.log(this.t)

        // console.log(this.orderCount)
        // console.log(this.totalCost, this.totalCost1)
        // console.log(this.totalPrice, this.totalPrice1)
        // console.log(res.data)
        // console.log(this.orderList)
      } else {
        this.$router.go(-1)
      }

      console.log(1111)

      console.log(this.t)
      console.log(this.p)
      console.log(this.w)
      console.log(this.carid)
      console.log(this.key)

      // this.carid = ids.join(',')
    },
    // 自动识别
    async autoSpot() {
      const {
        data: res
      } = await this.$http.get(
        '/api/index/strtoaddress?str=' + this.autoAdd + '&token=' + window.localStorage.getItem('token')
      )
      if (res.code) {
        this.ruleForm.provice_id = res.data.province_id
        this.ruleForm.query = res.data.detail
        this.ruleForm.shopping_phone = res.data.mobile
        this.ruleForm.shopping_name = res.data.name
         this.ruleForm.ext_number = res.data.ext_number
        this.ruleForm.address =
          res.data.province_id +
          ',' +
          res.data.city_id +
          ',' +
          res.data.county_id
        $('.address_picker select:first option:first').text(
          res.data.province_name
        )
        // this.selectProductInfo.data.region_id = res.data.province_id
        $('.address_picker select:eq(1) option:first').text(res.data.city_name)
        $('.address_picker select:last option:first').text(res.data.county_name)
        $('.address_picker select:first option:first')
      }
    },
    async autoaddress() {
        $('#addressBox>div').hide()
        $("#addressBox>div:contains('" + this.soaddress + "')").show()
    },
    // 快递
    async queryEDList() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http.post('api/car/expresslst', param)
      if (res.code == 1) {
        this.expressList = res.data
      } else {
        this.$confirm('获取地址信息失败,请刷新页面重试', '提示')
      }
    },
    // 支付
    async paymentOrder(kk, uid) {
      let that = this
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('amount', this.countPrice[kk])
      param.append('payway', this.zhifuMethod)
      param.append('key', this.key[kk])
      param.append('uid', uid)
      param.append('weight', this.w[kk].join(','))
      param.append('price', this.p[kk].join(','))
      param.append('total_price', this.t[kk].join(','))
      param.append('carid', this.carid[kk])
      param.append('cartype', 2)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/order/addorderD',
        data: param
      })

     if (res.code == 1) {
       let params = new URLSearchParams()
       params.append('amount', res.data.amount)
       params.append('order_pid', res.data.order_pid)
       params.append('payway', res.data.payway)
       params.append('uid', uid)
       params.append('token', window.localStorage.getItem('token'))
       const { data: result } = await this.$http({
         method: 'post',
         url: 'api/pays/submit',
         data: params
       })
       if (res.data.payway == '1') {
         if (res.code == 1) {
           this.$confirm({
             title: '提示',
             type: 'success',
             message: `支付成功,点击确定查看订单`,
             showClose: false,
             closeOnClickModal: false,
             callback: res => {
               if (res == 'confirm') {
                 this.$router.replace('/order')
               } else {
                 this.$router.replace('/detail')
               }
             }
           })
         } else {
           this.$confirm(res.msg, '提示')
         }
         return
       }
       const div = document.createElement('div')
       div.innerHTML = result // html code
       document.body.appendChild(div)
       document.forms.alipaysubmit.submit()
     } else if (res.code == 0) {
         if (res.msg == '余额不足') {
             this.$confirmm('余额不足，请充值', '提示', {
               confirmButtonText: '去充值',
               cancelButtonText: '取消',
               type: 'warning'
             })
             .then(() => {
               this.$router.push('/recharge')
             })
             .catch(() => {})
         } else {
           this.$confirm(res.msg, '提示', {
             confirmButtonText: '立即刷新',
             cancelButtonText: '确定',
             type: 'warning'
           })
             .then(() => {
               window.history.go(0)
             })
             .catch(() => {
               window.history.go(0)
             })
         }
     }
    },
    // 支付方式
    async queryPayMethods() {
      const { data: res } = await this.$http.get('api/index/payway')
      this.WeChatPay = res.data[3]
      this.AliPay = res.data[2]
    }
  },
  destroyed() {
    window.sessionStorage.removeItem('cartype')
  }
}
</script>

<style lang="less" scoped>
.sy_logo {
  width: 120px;
}
.header {
  width: 100%;
  height: 110px;
  background-color: #fff;
  margin-bottom: 30px;
  .w {
    line-height: 110px;
    .logo {
      cursor: pointer;
      float: left;
      line-height: 110px;
    }
    .msg {
      float: left;
      margin: 50px 0 30px 25px;
      width: 170px;
      height: 25px;
      border-left: 2px solid #999;
      line-height: 25px;
      text-align: center;
      color: #a77c5a;
      font-size: 22px;
    }
  }
}
strong {
  font-size: 14px;
  color: #333;
}
.co-red {
  color: #e83030 !important;
}
#content {
  background-color: #fff;
  padding: 20px;
  .checkout-steps {
    margin-bottom: 25px;
    .w {
      .orderInfo {
        display: block;
        font-size: 14px;
        color: #333;
        margin-bottom: 15px;
      }
      table {
        th {
          background-color: #fafafa;
          border: 1px solid #eee;
          height: 38px;
          line-height: 38px;
          text-align: center;
        }
        tr {
          border: 1px solid #eee;
        }
        td {
          font-size: 12px;
          color: #666666;
          border: 1px solid #eee;
          text-align: center;
          padding: 10px;
          .addressSettings {
            float: right;
            font-size: 12px;
            color: #a77c5a;
            padding: 2px 5px;
            background: #edfff6;
          }
          .delete {
            background-color: #bfbfbf;
          }
          .Chai {
            background-color: #a77c5a;
            margin-bottom: 10px;
          }
        }
        .address {
          text-align: left;
        }
      }
    }
  }
  .order-summary {
    margin-bottom: 30px;
    height: 95px;
    .tit {
      margin-bottom: 18px;
      strong {
        font-size: 14px;
        color: #333;
      }
      i {
        color: #999;
        font-size: 12px;
      }
    }
    .sy-item {
      margin-bottom: 8px;
      span {
        font-size: 12px;
        color: #666;
      }
      a {
        margin-left: 20px;
        color: #a77c5a;
      }
    }
  }
  .current {
    background: url('../assets/order/duigou.png') no-repeat right bottom;
  }
  .active {
    background-color: #d9e9d5;
  }
  #Virtualdiv {
    margin-bottom: 20px;
    .sy-panel-main {
      margin-top: 10px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      color: #666;
      select {
        height: 30px;
        width: 150px;
        margin: 0 10px;
      }
    }
  }
  #pay-methods {
    .methods {
      margin-top: 12px;
      .method-box {
        .balanceBox {
          position: relative;
        }
        .balanceInfo {
          position: absolute;
          right: 25px;
          top: 24px;
        }
        li {
          position: relative;
          float: left;
          width: 180px;
          height: 72px;
          margin-right: 20px;
          a {
            display: block;
            height: 100%;
            line-height: 72px;
            box-shadow: 1px 1px 6px 2px #eee;
            text-align: center;
          }
          a:hover {
            border: 1px solid #a77c5a;
          }
        }
      }
    }
  }
  #summary {
    padding: 30px 15px;
    .statistic {
      float: right;
      .list {
        text-align: right;
        margin-bottom: 8px;
        font-size: 12px;
        color: #666;
      }
    }
  }
  #foot {
    padding: 15px;
    background-color: #f2f2f2;
    .SY {
      float: right;
      width: 590px;
      .price {
        float: right;
        margin-bottom: 10px;
      }
      .userInfo {
        float: right;
      }
    }
  }
  #sticky-wrap {
    padding: 40px;
    button {
      float: right;
      width: 120px;
      height: 40px;
      line-height: 40px;
      background-color: #a77c5a;
      color: #fff;
      font-size: 16px;
    }
  }
  #addressBox {
    margin-top: 10px;
    .address-item {
      cursor: pointer;
      margin-bottom: 10px;
      margin-bottom: 10px;
      .un {
        float: left;
        width: 80px;
        height: 30px;
        background-color: #a77c5a;
        border: 1px solid #a77c5a;
        font-size: 12px;
        color: #fff;
        margin-right: 10px;
      }
      p {
        float: left;
        line-height: 30px;
      }
      .address1 {
        margin-left: 5px;
        max-width: 140px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .Addressquery {
        margin: 0 5px;
        max-width: 350px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .caozuo {
        width: 200px;
        float: right;
        font-size: 12px;
        line-height: 30px;
        .set {
          color: #4da5ff;
          cursor: pointer;
        }
        .edit {
          color: #a77c5a;
          margin-left: 8px;
          cursor: pointer;
        }
        .del {
          background: #fff;
          margin-left: 8px;
        }
        .def {
          color: #fff;
          background-color: #bfbfbf;
          padding: 2px 5px;
        }
      }
    }
  }
}
select {
  height: 30px;
}
</style>
